import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { LookupService } from '../services/lookup/lookup.service';
import { Lookup } from '../app.types';
import { filter, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { combineLatest, merge, Subject } from 'rxjs';
import { HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from '../core/modal/modal.component';

@Component({
    selector: 'lookup-form-modal',
    templateUrl: './lookup-form-modal.component.html',
    styleUrls: ['./lookup-form-modal.component.scss'],
    standalone: false
})
export class LookupFormModalComponent implements OnInit, OnDestroy {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Output() close: EventEmitter<string> = new EventEmitter();
  @Input() windowClass: string = null;
  @Input() backdrop = false;

  @Input() lookupName: string = null;
  @Input() controllerName: string = null;

  data: Lookup[] = [];
  resultsLength: number;
  initialPageSize = 5;

  paging = { pageNumber: 1, pageIndex: 0, pageSize: 5, length: 0, previousPageIndex: 0 };

  newValue = '';
  newValueID: string = null;

  unSubscribe$ = new Subject();
  tableRefresh$ = new Subject();
  pageChange$ = new Subject();
  
  constructor(private lookupService: LookupService, 
    private toastrService: ToastrService) {}

  ngOnDestroy(): void {
    this.unSubscribe$.next(null);
    this.unSubscribe$.complete();
  }

  ngOnInit(): void {
    merge(
      this.tableRefresh$,
      this.pageChange$
    ).pipe(
      startWith({}),
      switchMap(() => {
        const pagerOptions = {
          pageSize: this.paging.pageSize,
          page: this.paging.pageIndex + 1,
          orderBy: 'name'
        }

        return this.lookupService.getList(this.controllerName, pagerOptions);
      }),
      takeUntil(this.unSubscribe$)
    ).subscribe(x => {
      this.data = x.results;
      this.resultsLength = x.totalNumberOfRecords;
    });
  }

  pagingChanged(paging: { pageIndex: number; pageSize: number }): void {
    if (paging == null) {return;}

    this.paging = { ...this.paging, ...paging };
    this.pageChange$.next(null);
  }

  addNew(){
    this.lookupService.addNew(this.controllerName, {name: this.newValue})
      .subscribe(x => {
        if(x instanceof HttpResponse && x.ok){
          this.toastrService.success(`${this.lookupName} added successfully`);
          this.newValueID = x.body.id;
          this.modal.closeModal();
        }
      });
  }

  delete(lookup: Lookup){
    this.lookupService.delete(this.controllerName, lookup)
      .pipe(filter(x => (x instanceof HttpResponseBase)))
      .subscribe(x => {
        if(x instanceof HttpResponse && x.ok){
          this.toastrService.success(`${this.lookupName} deleted successfully`);
          this.tableRefresh$.next(null);
        } else {
          this.toastrService.error(`${this.lookupName} cannot be deleted. Check to see if it is linked to a device.`);
        }
      });
  }
  
  modalCleanup() {
    this.close.emit(this.newValueID);
  }
}
